import * as constants from './constants'
import { Alert } from 'types/alert'

export const removeAlert = () => {
  return {
    type: constants.REMOVE_ALERT,
  }
}

export const testAlert = (alert: Alert) => {
  return {
    type: constants.ADD_ALERT,
    alert: alert,
  }
}

export const addAlert = (alert: Alert) => {
  return {
    type: constants.ADD_ALERT,
    alert: alert,
  }
}
